import React from 'react';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { COOKIES_STORE_NAME } from 'modules/cookies';
import { useRegionIdSelector } from 'modules/model-json';
import { useStoreon } from 'storeon/react';
import { State } from 'store/types';
import { ExperimentCookie } from 'types/common';
import { UpdatedStorage } from './updated';
import { KzVariant } from './kz';

/**
 * Вью лендинга Спасео Куб
 */
export const Storage = () => {
  const { cookies } = useStoreon<State>(COOKIES_STORE_NAME);
  const regionId = useRegionIdSelector();
  const isRuRegion = regionId !== KAZAKHSTAN;
  const experimentCookie = (cookies._proekt_storage || 'A') as ExperimentCookie;

  return (
    (experimentCookie === 'A' || !isRuRegion)
      ? <KzVariant regionId={regionId} isRuRegion={false} />
      : <UpdatedStorage experimentCookie={experimentCookie} regionId={regionId} />
  );
};
